import React, {useState, useEffect} from 'react';
import styles from './InvoicePreview.module.css';
import InvoiceDetails from '../../components/InvoiceDetails/InvoiceDetails';
import { useNavigate, useParams } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { ArrowBackIosNew } from '@mui/icons-material';
import Status from '../../components/Status/Status';
import useApproval from '../../hooks/useApproval';
import axios from 'axios';
import keycloak from '../../keycloak';

export default function InvoicePreview() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [assignedApprover, setAssignedApprover] = useState('hi123@ttg.com');
    const invoiceID = sessionStorage.getItem("selectedInvoiceID") || id;
    const { data } = useApproval(invoiceID);
    const [pageLoading, setLoading] = useState(true);
    const [invoiceStatus, setInvoiceStatus] = useState('PENDING');
    const [pdfBlobUrl, setPdfBlobUrl] = useState('');

    const goBack = () => {
        sessionStorage.removeItem("selectedInvoiceID");
        navigate('/');
    };

    const [formData, setFormData] = useState({});
    const normalizedStatus = String(invoiceStatus || '').replace(/\s+/g, '').toLowerCase();
    const isEditRequired = normalizedStatus === 'editrequired';
    const isPending = normalizedStatus === 'pending';
    const isOwner = (keycloak.tokenParsed?.email || '') === (formData?.supplierEmail || '');
    const approverEmails = Array.isArray(assignedApprover)
        ? assignedApprover.filter((email) => String(email || '').trim() !== '')
        : String(assignedApprover || '')
            .split(/[,\n;]+/)
            .map((email) => email.trim())
            .filter((email) => email !== '');

useEffect(() => {
    if (data && data.getInvoice) {
        const invoiceData = data.getInvoice.body;
        setFormData(invoiceData);
        setLoading(false);
        setAssignedApprover(invoiceData.approverEmails);

        if (invoiceData.status) {
            const formattedStatus = invoiceData.status === 'EditRequired'
                ? 'EDIT REQUIRED'
                : invoiceData.status.toUpperCase();
            setInvoiceStatus(formattedStatus);
        }

        const pdfUrl = invoiceData.invoiceFilename
            ? invoiceData.invoiceFilename.startsWith("http")
                ? invoiceData.invoiceFilename
                : `http://localhost:8000${invoiceData.invoiceFilename}`
            : null;
        if (pdfUrl) {
            (async () => {
                try {
                    const response = await axios.get(pdfUrl, {
                        headers: {
                            'Authorization': `Bearer ${keycloak.token}`
                        },
                        responseType: 'blob'
                    });
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const blobUrl = URL.createObjectURL(blob);
                    setPdfBlobUrl(blobUrl);
                } catch (error) {
                    console.error('Error fetching PDF:', error);
                }
            })();
        }
    }
}, [data]);

useEffect(() => {
    return () => {
        if (pdfBlobUrl) {
            URL.revokeObjectURL(pdfBlobUrl);
        }
    };
}, [pdfBlobUrl]);

    if (!pageLoading)
    return (
        <div className={styles.pageContainer}>
            <div className={styles.header}>
                <div style={{ width: "30px" }}>
                    <IconButton onClick={goBack} sx={{ color: 'var(--theme-text)' }}>
                        <ArrowBackIosNew />
                    </IconButton>
                </div>
                <div className={styles.title}>Invoice no. {id}</div>
            </div>

            <div className={styles.invoiceContainer}>
                <div className={styles.preview}>
                    {pdfBlobUrl ? (
                        <embed
                            src={pdfBlobUrl}
                            type="application/pdf"
                            className={styles.previewFile}
                        />
                    ) : (
                        <div className={styles.previewPlaceholder}>
                            No bill uploaded!
                        </div>
                    )}
                </div>

                <div className={styles.formContainer}>
                    <div className={styles.details}>
                        <div className={styles.items}>
                            <InvoiceDetails
                                onApproverPage={false}
                                formData={formData}
                                setFormData={setFormData}
                                allowEditing={false}
                            />
                        </div>
                    </div>

                    <div className={styles.commentSection}>
                        <h3>Supplier Note</h3>
                        <div className={styles.commentContainer}>
                            <div className={styles.messageItem}>
                                {formData.userNote || 'No supplier note.'}
                            </div>
                        </div>
                    </div>

                    <div className={styles.commentSection}>
                        <h3>Approver Note</h3>
                        <div className={styles.commentContainer}>
                            <div className={styles.messageItem}>
                                {formData.rejectNote || 'No approver note.'}
                            </div>
                        </div>
                    </div>

                    <div className={styles.approvalInfo}>
                        <div className={styles.approvalColumnLeft}>
                            {isOwner && (isEditRequired || isPending) && (
                                <button className={styles.modifyButton} onClick={() => navigate(`/submit-invoice/edit/${invoiceID}`)}>
                                    MODIFY INVOICE
                                </button>
                            )}
                        </div>
                        <div className={styles.approvalColumnMiddle}>
                            <div className={styles.footer}>
                                {approverEmails.length > 1 ? 'Approvers:' : 'Approver:'}
                            </div>
                            <div className={styles.approverEmails}>
                                {approverEmails.length > 0
                                    ? approverEmails.map((email, index) => (
                                        <div key={`${email}-${index}`}>{email}</div>
                                    ))
                                    : <div>Unassigned</div>}
                            </div>
                        </div>
                        <div className={styles.approvalColumnRight}>
                            <Status label={invoiceStatus}/>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}
